import state from "./state.js";
import getters from "./getters/index.js";
import actions from "./actions/index.js";
import mutations from "./mutations/index.js";

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
